import script from "./tooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./tooltip.vue?vue&type=script&setup=true&lang=js"

import "./tooltip.vue?vue&type=style&index=0&id=5f22f1af&lang=css"

const __exports__ = script;

export default __exports__